__turbopack_context__.v({
  "content": "cdyAIG_content",
  "heading": "cdyAIG_heading",
  "hero": "cdyAIG_hero",
  "image": "cdyAIG_image",
  "statusDot": "cdyAIG_statusDot",
  "tokens": "cdyAIG_tokens",
});
